export default class ProductFeaturedImage {
  constructor() {
    const $els = document.querySelectorAll('.js-qr-product-featured-image');
    $els.forEach($el => new InlineVideo($el));
  }
}

class InlineVideo {
  constructor($el) {
    this.$video = $el.querySelector('.js-video');
    this.$play = $el.querySelector('.js-play');

    if (! this.$play) return;

    this.$play.addEventListener('click', (e) => {
      e.preventDefault();

      this.$play.classList.add('hidden');
      this.$video.classList.remove('hidden');

      this.$video.firstChild.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
    });
  }
}
